import React, { HTMLAttributes, forwardRef } from 'react';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'active' | 'inactive' | 'invited' | 'default';
  showDot?: boolean;
}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ variant = 'default', showDot, children, className = '', ...props }, ref) => {
    const variantClass = variant === 'default' ? '' : variant;
    const combinedClassName = `st-pill ${variantClass} ${className}`.trim();

    return (
      <span ref={ref} className={combinedClassName} {...props}>
        {showDot && <span className="st-dot" />}
        {children}
      </span>
    );
  }
);

Badge.displayName = 'Badge';
